// ARQUIVO ATUALIZADO
import React, { useState } from 'react';
import useData from '../../hooks/useData';
import useToast from '../../hooks/useToast';
import GlassButton from '../ui/Button';
import { AddIcon, DeleteIcon, EditIcon, SaveIcon, SparklesIcon } from '../ui/Icons';

const ServiceManagerModal = ({ onClose, onSelectService }) => {
    const { services, handleSaveService, handleDeleteService } = useData();
    const { showToast } = useToast();
    const [newService, setNewService] = useState({ description: '', price: 0 });
    const [editingId, setEditingId] = useState(null);

    const handleAddDefaults = async () => {
        const defaultServices = [
            { description: 'Identidade Visual', price: 0 },
            { description: 'Logomarca Simples', price: 0 },
            { description: 'Kit Social Media', price: 0 },
            { description: 'Kit Motion', price: 0 },
            { description: 'Diagramação', price: 0 }
        ];

        let servicesAdded = 0;
        for (const defaultService of defaultServices) {
            const exists = services.some(s => s.description.toLowerCase() === defaultService.description.toLowerCase());
            if (!exists) {
                await handleSaveService(defaultService);
                servicesAdded++;
            }
        }

        if (servicesAdded > 0) {
            showToast(`${servicesAdded} serviço(s) padrão adicionado(s) com sucesso!`);
        } else {
            showToast("Todos os serviços sugeridos já estão na sua lista.", "info");
        }
    };

    const handleSave = async () => {
        if (!newService.description || newService.price < 0) return;
        
        if (editingId) {
            await handleSaveService({ id: editingId, ...newService });
            setEditingId(null);
        } else {
            await handleSaveService(newService);
        }
        setNewService({ description: '', price: 0 });
    };

    const handleEdit = (service) => {
        setEditingId(service.id);
        setNewService({ description: service.description, price: service.price });
    };

    return (
        // --- INÍCIO DA ALTERAÇÃO ---
        // Removido o container e título, pois agora são gerenciados pelo Modal genérico
        <>
            <div className="flex justify-end mb-4 -mt-2">
                <GlassButton onClick={handleAddDefaults} className="!text-xs !py-1 !px-3">
                    <SparklesIcon size={14}/>
                    <span className="ml-2">Adicionar Sugestões</span>
                </GlassButton>
            </div>

            <div className="space-y-2 max-h-64 overflow-y-auto pr-2 mb-4">
                {services.length > 0 ? services.map(service => (
                    <div key={service.id} className="flex justify-between items-center bg-white/5 p-3 rounded-lg">
                        <div>
                            <p className="font-semibold">{service.description}</p>
                            <p className="text-sm text-gray-300">{Number(service.price).toLocaleString('pt-BR', { style: 'currency', currency: 'BRL' })}</p>
                        </div>
                        <div className="flex items-center gap-2">
                            <button onClick={() => handleEdit(service)} className="text-blue-300 hover:underline text-sm p-1"><EditIcon size={16}/></button>
                            <button onClick={() => handleDeleteService(service.id)} className="text-red-400 hover:underline text-sm p-1"><DeleteIcon size={16}/></button>
                            <GlassButton onClick={() => onSelectService(service)} className="!text-xs !py-1 !px-2">Adicionar</GlassButton>
                        </div>
                    </div>
                )) : (
                    <p className="text-center text-gray-400 py-8">Seu banco de serviços está vazio. Adicione um serviço abaixo ou clique em "Adicionar Sugestões".</p>
                )}
            </div>

            <div className="bg-white/10 p-4 rounded-lg flex items-end gap-2">
                <div className="flex-grow">
                    <label className="text-xs mb-1 block">Descrição do Serviço</label>
                    <input type="text" placeholder="Ex: Design de Logotipo" value={newService.description} onChange={(e) => setNewService(p => ({ ...p, description: e.target.value }))} className="w-full p-2 bg-black/20 rounded"/>
                </div>
                <div>
                    <label className="text-xs mb-1 block">Preço (R$)</label>
                    <input type="number" placeholder="600.00" value={newService.price} onChange={(e) => setNewService(p => ({ ...p, price: parseFloat(e.target.value) || 0 }))} className="w-32 p-2 bg-black/20 rounded"/>
                </div>
                <GlassButton onClick={handleSave} className="!bg-indigo-500 h-10">
                    {editingId ? <SaveIcon /> : <AddIcon />}
                </GlassButton>
            </div>
            
            <div className="mt-6 text-right">
                <GlassButton onClick={onClose}>Fechar</GlassButton>
            </div>
        </>
        // --- FIM DA ALTERAÇÃO ---
    );
};

export default ServiceManagerModal;